import { round } from 'lodash';

export const VALUE_TO_LABEL_GAP = 16;
export const LABEL_HORIZONTAL_PADDING = 8;
export const VALUE_FONT_SIZE = 13;
export const VALUE_ROW_LINE_HEIGHT = 1.25;
export const LABEL_FONT_SIZE = 12;
export const LABEL_LINE_HEIGHT = 1.4;
export const LABEL_MAX_LINES = 2;

export const labelAreaHeight = round(
  LABEL_FONT_SIZE * LABEL_LINE_HEIGHT * LABEL_MAX_LINES,
  2,
);
